import { Text } from '@backyard-ui/core';

import { type CategoriesMapItem } from '@/infra/services/site-map/get-categories-map';
import { type ProductsMapItem } from '@/infra/services/site-map/get-products-map';

interface MapLinkListProps {
  items: CategoriesMapItem[] | ProductsMapItem[];
}

export default function MapLinkList(props: Readonly<MapLinkListProps>) {
  const { items } = props;

  if (!items.length) {
    return null;
  }

  return (
    <ul className="mt-4 pl-6">
      {items.map((item) => (
        <li key={item.name} className="mb-4" data-testid="link-item">
          <Text
            size="lg"
            color="primary-700"
            weight="bold"
            decoration="underline"
            asChild
          >
            <a className="inline-block" href={item.url}>
              {item.name}
            </a>
          </Text>

          {item.children &&
            item.children.length > 0 &&
            item.children.map((child) => (
              <MapLinkList key={child.name} items={child.children || []} />
            ))}
        </li>
      ))}
    </ul>
  );
}
